import React, { useCallback, useState } from 'react';
import { STEPS, types, useLocalChat } from '@guuru/chat-web';
import SmartFormPredictOptions from './SmartFormPredictOptions';
import ChatPredictOptions from './ChatPredictOptions';
import ChatRenderText from '../Text';

interface ChatRenderPredictionConfirmationProps {
  message: React.ComponentProps<typeof ChatPredictOptions>['message'] & {
    text: string;
    metadata?: {
      subscriptionPriority: number;
      subscriptionTarget: string;
    };
  };
  readOnly?: boolean;
  preview?: boolean;
  // eslint-disable-next-line no-unused-vars
  dispatch?: (_: {
    type: string;
    processArgs: {
      response: string;
      text: string;
      smartFormStyle: boolean;
      subscriptionPriority?: number;
      subscriptionTarget?: string;
    }
  }) => void;
}

const ChatRenderPredictionConfirmation = function ({
  message,
  readOnly = false,
  preview = false,
  dispatch = () => {},
}: ChatRenderPredictionConfirmationProps) {
  const { currentChatStep } = useLocalChat();
  const requestIntentOption = currentChatStep === STEPS.makePrediction;
  const [
    showOptions,
    setShowOptions,
  ] = useState(preview || requestIntentOption);

  const {
    smartFormStyle = false,
    metadata: {
      subscriptionPriority,
      subscriptionTarget,
    } = {},
  } = message;

  const handleSelection = useCallback((
    option: string,
    optionTranslated: string,
  ) => {
    setShowOptions(false);
    return dispatch({
      type: types.CHAT_RUN_NEXT_STEP,
      processArgs: {
        response: option,
        text: optionTranslated,
        smartFormStyle,
        subscriptionPriority,
        subscriptionTarget,
      },
    });
  }, [
    dispatch,
    smartFormStyle,
    subscriptionPriority,
    subscriptionTarget,
  ]);

  if (readOnly) {
    return <ChatRenderText message={message} />;
  }

  const PredictOptions = smartFormStyle
    ? SmartFormPredictOptions
    : ChatPredictOptions;
  return (
    <PredictOptions
      message={message}
      onSelect={handleSelection}
      showOptions={showOptions && currentChatStep === STEPS.makePrediction}
    />
  );
};

export default ChatRenderPredictionConfirmation;
